import React, { JSXElementConstructor, CSSProperties } from 'react'
import cn from 'classnames'

interface Props {
  variant?: Variant
  className?: string
  style?: CSSProperties
  children?: React.ReactNode | any
  html?: string
  id?: string
}

export type Variant =
  | 'mediumHeading'
  | 'heading'
  | 'body'
  | 'pageHeading'
  | 'superHeading'
  | 'subHeading'
  | 'headingLight'

const Text: React.FC<Props> = ({ style, className, variant = 'body', children, html, id }) => {
  const componentsMap: {
    [P in Variant]: React.ComponentType<any> | string
  } = {
    body: 'p',
    mediumHeading: 'h3',
    heading: 'h4',
    headingLight: 'h4',
    pageHeading: 'h1',
    superHeading: 'h1',
    subHeading: 'h2',
  }

  const Component:
    | JSXElementConstructor<any>
    | React.ReactElement<any>
    | React.ComponentType<any>
    | string = componentsMap![variant!]

  const htmlContentProps = html
    ? {
        dangerouslySetInnerHTML: { __html: html },
      }
    : {}

  return (
    <Component
      id={id}
      className={cn(
        {
          'whitespace-pre-line': variant === 'body',
          'text-lg font-bold md:text-xl lg:text-2xl 2xl:text-3xl': variant === 'mediumHeading',
          'text-sm font-semibold text-black md:text-base xl:text-lg': variant === 'heading',
          'text-sm font-semibold text-white md:text-base xl:text-lg': variant === 'headingLight',
          'text-2xl font-extrabold md:text-3xl lg:text-4xl lg:leading-normal xl:text-5xl':
            variant === 'pageHeading',
          'text-2xl font-extrabold md:text-4xl lg:text-6xl xl:text-7xl': variant === 'superHeading',
          'text-lg font-bold md:text-2xl xl:text-3xl 2xl:text-4xl': variant === 'subHeading',
        },
        className,
      )}
      style={style}
      {...htmlContentProps}
    >
      {children}
    </Component>
  )
}

export default Text
